"use client";
import { useContext, useEffect } from "react";

import useAnalyticsActionEvents from "@stadium/services/analytics/hooks/use-action-events";

import useRouter from "@stadium/hooks/lib/use-custom-route";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";
import Button from "@stadium/shared/src/components/shared/button";

import useWidgets from "@stadium/shared/src/components/recognise-widget/hooks/use-widget";
import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import {
  QUICK_RECOGNISE_KEY,
  QUICK_RECOGNIZE_KEY,
} from "@stadium/shared/src/constants/quick-recognise";
import { GTAG } from "@stadium/services/analytics/constants/services";
import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";

import recognizeSpin from "@stadium/shared/src/assets/images/recognize-spin.svg";

import styles from "./main.module.scss";

const StartButton = () => {
  const { query, replace, pathname } = useRouter();
  const { widgets } = useWidgets();
  const { workspaceSlug } = useWorkspaceContext();
  const { isDesktopDevice } = useContext(CurrentDeviceContext);
  const { currentUserData } = useCurrentUserContext();

  const { trackEvent } = useAnalyticsActionEvents([GTAG]);

  const { [QUICK_RECOGNISE_KEY]: quickRecognise, [QUICK_RECOGNIZE_KEY]: quickRecognize } = query;

  const enableQuickRecognise = quickRecognise === "true" || quickRecognize === "true";

  useEffect(() => {
    if (enableQuickRecognise && widgets) {
      trackEvent({
        eventName: "recognition_flow_started",
        eventProperties: {
          entry_source: pathname,
          component: "redeem_step_recognize",
          user_id: currentUserData?.spreeId,
        },
      });
      widgets.renderGiftWidget({ workspaceSlug });
      const url = new URL(window.location.href);
      url.searchParams.delete(QUICK_RECOGNISE_KEY);
      url.searchParams.delete(QUICK_RECOGNIZE_KEY);
      replace(url);
    }
  }, [enableQuickRecognise, widgets]);

  return (
    <div className={styles.recogniseBtnContainer}>
      <Button
        styleType="primary-outline"
        className={styles.recogniseBtn}
        onClick={() => {
          if (widgets) {
            trackEvent({
              eventName: "recognition_flow_started",
              eventProperties: {
                entry_source: pathname,
                component: "top_nav",
                user_id: currentUserData?.spreeId,
              },
            });
            widgets.renderGiftWidget({ workspaceSlug });
          }
        }}
      >
        <Multimedia
          type="image"
          src={recognizeSpin}
          height={18}
          width={18}
          alt="Recognize Icon"
          className={styles.recognizeSpin}
          isNextImage={false}
        />
        {isDesktopDevice && <span className={styles.recognizeBtnTitle}>Recognize</span>}
      </Button>
      <span className={styles.recogniseBtnShadow} />
    </div>
  );
};

export default StartButton;
